import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";
import TextArea from "../../../../Component/DigitalMarketing/Forms/TextArea";
import Input from "../../Customer/Component/Input";

export const GoogleLabel = [
  {
    tag: InputBox,
    label: "Client Email",
    type: "text",
    placeholder: "Enter patient name",
    key_name: "clientEmail",
    style: "chat-input",
  },
  {
    tag: InputBox,
    label: "Private Key",
    type: "text",
    placeholder: "Enter patient name",
    key_name: "privateKey",
    style: "chat-input",
  },
  {
    tag: InputBox,
    label: "View Id",
    type: "text",
    placeholder: "Enter patient name",
    key_name: "viewId",
    style: "chat-input",
  },
];
export const ChatBotLabel = [
  {
    tag: InputBox,
    label: "Detail API",
    type: "text",
    placeholder: "Enter detail API",
    key_name: "clientEmail",
    style: "chat-input",
  },
  {
    tag: InputBox,
    label: "Timing API",
    type: "text",
    placeholder: "Enter timing API",
    key_name: "privateKey",
    style: "chat-input",
  },
];
export const WhatsAppLabel = [
  {
    tag: InputBox,
    label: "Api key",
    type: "text",
    placeholder: "Enter API KEY",
    key_name: "apiKey",
    style: "chat-input",
    validation: "required",
    required: true,
    mandatory: true,
  },
  {
    tag: InputBox,
    label: "App name",
    type: "text",
    placeholder: "Enter APP NAME",
    key_name: "appName",
    style: "chat-input",
    validation: "required",
    required: true,
    mandatory: true,
  },
  {
    tag: InputBox,
    label: "Phone number",
    type: "number",
    placeholder: "Enter PHONE NUMBER",
    key_name: "sourceMobileNumber",
    style: "chat-input",
    validation: "phone",
    required: true,
    mandatory: true,  },
    {
      tag: InputBox,
      label: "Admin Phone number",
      type: "number",
      placeholder: "Enter ADMIN PHONE NUMBER",
      key_name: "adminMobileNumber",
      style: "chat-input",
      validation: "phone",
      required: true,
      mandatory: true,  },
];
export const FacebookLabel = [
  {
    tag: InputBox,
    label: "User Account Id",
    type: "text",
    placeholder: "Enter User Account Id",
    key_name: "userAccountId",
    style: "chat-input",
    validation: "required",
    required: true,
    mandatory: true,
  },
  // {
  //   tag: InputBox,
  //   label: "Campaign Id",
  //   type: "text",
  //   placeholder: "Enter Campaign Id",
  //   key_name: "campaignId",
  //   style: "chat-input",
  //   validation: "required",
  //   required: true,
  //   mandatory: true,
  // },
  {
    tag: InputBox,
    label: "Access Token",
    type: "number",
    placeholder: "Enter Access Token",
    key_name: "accessToken",
    style: "chat-input",
    validation: "required",
    required: true,
    mandatory: true,  },
    
];
export const templateLabel = [

  {
    tag: InputBox,
    label: "Ownchat Template Id",
    type: "text",
    placeholder: "Enter Ownchat TEMPLATE ID",
    key_name: "templateId",
    style: "chat-input",
    validation: "templateId" 
  },
 
];
export const templatesampleLabel = [
  {
    tag: TextArea,
    label: "Sample Template",
    type: "text",
    key_name: "apikey",
    style: "chat-input",
    validation: "remainder" 
  },
 
 
];
export const remainder =[
  { value: "1", label: "Created" },
  { value: "2", label: "Converted" },
  { value: "3", label: "In Progress" },
  { value: "4", label: "Not Intrested" },
  { value: "5", label: "Not Answered" },
];